import { Component, OnDestroy, OnInit, Output } from '@angular/core';
import { LoginState } from '../../source/appstates/loginstates/loginState';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import * as loginActions from '../../source/appstates/loginstates/loginActions'
import * as appState from '../../source/appstates/appState'
import { TranslateModule } from '@ngx-translate/core';

declare var $: any;
function showforgotpasswordModal() {
  $("#forgotpassword").modal("show");
}
function hideforgotpasswordModal() {
  $("#forgotpassword").modal("hide");
}
@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [CommonModule,ReactiveFormsModule,TranslateModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css'
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {

  private storeSub!: Subscription;
  form!: FormGroup;
  errorMessage: string="";  
  private keyupHandler!: (evt: KeyboardEvent) => void;

  constructor(private store: Store<appState.AppState>) { }

  ngOnInit() {

    this.form = new FormGroup({
      "email": new FormControl(null, [Validators.required, Validators.email, Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]),

      "login": new FormControl(null, [Validators.required, Validators.minLength(4), Validators.maxLength(15), Validators.pattern('[a-zA-Z0-9]*')]),
    })

    this.storeSub = this.store.select("loginState").subscribe(
      (loginState: LoginState) => {
        // console.log(loginState)
        if (loginState.forgotPasswordResponse) {
          if (loginState.forgotPasswordResponse.success === true) {
            this.errorMessage = ""; 
          }
          if (loginState.forgotPasswordResponse.description) { 
            setTimeout(() => {
              this.errorMessage = '';
              this.errorMessage = 'PROVIDED_EMAIL_OR_USERNAME_DOES_NOT_EXISTS';
            }, 1000)

          }
          if (loginState.forgotPasswordErrorResponse) { 
            this.errorMessage = loginState.forgotPasswordErrorResponse.message;
          }
        }
      }
    ) 
    this.keyupHandler = (evt: KeyboardEvent) => {
      if (evt.key === 'Enter' && this.form.valid) {
        this.onFormSubmit();
      }
    };
  
    document.addEventListener('keyup', this.keyupHandler);
  }
  onInputFocus() {
    this.errorMessage = "";
  }
  onFormSubmit() {
    this.store.dispatch(new loginActions.ForgotPasswordStart(this.form.value));
    this.form.reset()
  }
  ngOnDestroy() {
    if (this.storeSub) {
      this.storeSub.unsubscribe();
    }
    if (this.keyupHandler) {
      document.removeEventListener('keyup', this.keyupHandler);
    }
  } 
  userNameValid(event:any) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)

    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || (k >= 48 && k <= 57));
}
  emailValid(event:any) {
    var k;
    k = event.charCode;  
    console.log(k)//         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k >= 33 && k <= 47 || k >= 60 && k <= 64 || (k >= 48 && k <= 58) || k >= 91 && k <= 96 || k >= 123 && k <= 126);
  }
}
